import { VisualAsset } from '../Content';
import { NebSectionImageAttributes } from '../Sections';
import { BaseScreenAttributes } from './BaseScreenAttributes';
import { ScreenType } from './ScreenType';

export const NebInitialVariant = {
  DEFAULT: 'default',
} as const;

export type NebInitialVariant = (typeof NebInitialVariant)[keyof typeof NebInitialVariant];

export type NebInitialRatingTag = {
  image: VisualAsset;
  topText: string;
  bottomText: string;
};

export type NebInitialChip = {
  image: VisualAsset;
  text: string;
};

export type NebInitialPolicy = {
  basic: string;
  withCheckbox: string;
  withoutCheckbox: string;
  withCheckboxError: string;
};

type NebInitialDefaultMain = {
  variant: typeof NebInitialVariant.DEFAULT;
  ratingTags: Array<NebInitialRatingTag>;
  image: NebSectionImageAttributes['content'];
  headings: Array<string>;
  chips: Array<NebInitialChip>;
};

export type NebInitialMain = NebInitialDefaultMain;

export interface NebInitialAttributes extends BaseScreenAttributes {
  screenType: ScreenType.NEB_INITIAL;
  content: {
    main: NebInitialMain;
    button: string;
    policy: NebInitialPolicy;
  };
}
